import {
  BookOpenIcon,
  CurrencyDollarIcon,
  LightBulbIcon,
  NewspaperIcon,
  StarIcon,
} from '@heroicons/react/24/solid';
import { BlogCategory } from '@/constants/blog.const';

export function BlogCategoryIcon({
  blogCategory,
  className = 'w-4',
}: {
  blogCategory: BlogCategory;
  className?: string;
}): React.ReactNode | null {
  switch (blogCategory) {
    case BlogCategory.Guides:
      return <BookOpenIcon className={className} />;
    case BlogCategory.Reviews:
      return <StarIcon className={className} />;
    case BlogCategory.News:
      return <NewspaperIcon className={className} />;
    case BlogCategory.Tips:
      return <LightBulbIcon className={className} />;
    case BlogCategory.Betting:
      return <CurrencyDollarIcon className={className} />;
    default:
      blogCategory satisfies never;
      return null;
  }
}
